import './CmdBarEdit.css';

/**
 * CmdEditOptions — dropdown list for CmdBarEdit autocomplete.
 *
 * Renders command matches or param option rows depending on mode.
 * Items are filtered before being passed in — this component only renders.
 * Param rows show label (short display text) — not the full hint value.
 *
 * @param {'commands'|'params'} props.mode
 * @param {{ cmd: string, hint: string }[]}                    props.matches   - command rows (mode=commands)
 * @param {{ name: string, label: string, hint: string }[]}   props.params    - param rows (mode=params)
 * @param {number}                                             props.activeIndex
 * @param {boolean}                                            [props.dropUp]  - render above the input instead of below
 * @param {object}                                             [props.innerRef] - ref forwarded to the dropdown root, used to measure its height for flip detection
 * @param {function({ cmd, hint, params }): void}             props.onSelectCommand
 * @param {function({ name, label, hint }): void}             props.onSelectParam
 */
export default function CmdEditOptions({ mode, matches, params, activeIndex, dropUp, innerRef, onSelectCommand, onSelectParam }) {
    const dropdownClass = `cbe-dropdown${dropUp ? ' cbe-dropdown--up' : ''}`;

    if (mode === 'commands') {
        return (
            <div ref={innerRef} className={dropdownClass}>
                {matches.map((m, i) => (
                    <div
                        key={m.cmd}
                        className={`cbe-row${i === activeIndex ? ' cbe-row--active' : ''}`}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            onSelectCommand(m);
                        }}
                    >
                        <span className="cbe-row-cmd">{m.cmd}</span>
                        <span className="cbe-row-hint">{m.hint}</span>
                    </div>
                ))}
            </div>
        );
    }

    if (mode === 'params') {
        return (
            <div ref={innerRef} className={dropdownClass}>
                {params.map((p, i) => (
                    <div
                        key={p.name + '-' + p.hint}
                        className={`cbe-row${i === activeIndex ? ' cbe-row--active' : ''}`}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            onSelectParam(p);
                        }}
                    >
                        <span className="cbe-row-cmd">{p.label}</span>
                    </div>
                ))}
            </div>
        );
    }

    return null;
}
